// extracted by mini-css-extract-plugin
export default {"one_new":"style_one_new__sB5aq","moli":"style_moli__OyfIn","min":"style_min__okWFm","max":"style_max__pazYX"};